<template>
	<div>
		<!-- Discounts and Taxes -->
		<div
			class="xs-12 p3 bb1 bc7"
			v-if="computedDiscounts.length > 0 || hasDiscountActions"
		>
			<div class="xs-12 fs3 lh125 fw7 c1">{{ $t("discount_codes") }}</div>
			<j-list
				:list="computedDiscounts"
				class="b1 bc7 mt2"
				v-if="computedDiscounts.length > 0"
			>
				<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
					<div class="flex wrap xs-6 xs-left xs-middle">
						<div class="xs-12 fw7 c6 lh125">{{ item.label }}</div>
						<div class="xs-12 c6 lh125">{{ $t("order") }}: {{ item.order }}</div>
					</div>
					<div class="flex xs-6 wrap xs-right xs-middle lh125">
						<div class="mr3 xs-right ta3">
							<div class="lh125">{{ item.value }}</div>
							<div class="c6 lh125">{{ item.summary }}</div>
						</div>
						<crm-icon
							name="delete"
							class="cu2 remove-discount"
							color="cError"
							size="small"
							@click.native="removeDiscount(item)"
						/>
					</div>
				</div>
			</j-list>

			<!-- Add button and loading state -->
			<div class="flex xs-12 xs-between" v-if="hasDiscountActions">
				<j-button
					v-can:or="['writeQuotes', 'writePolicies']"
					size="xsmall"
					class="mt2"
					@click="$modal.show(`addDiscount_${id}`)"
				>{{ $t("add_discount") }}</j-button>
			</div>
		</div>
		<core-modal :name="`addDiscount_${id}`" :headline="$t('add_discount')">
			<add-discount
				:pricing="pricing"
				:hasDiscountLogic="hasDiscountLogic"
				:addDiscountWithCode="addDiscountWithCode"
				:addDiscountWithoutCode="addDiscountWithoutCode"
				:nameOptions="nameOptions"
				@created="onCreated('discount')"
				@cancelled="$modal.hide(`addDiscount_${id}`)"
			/>
		</core-modal>
	</div>
</template>

<script>
import CoreModal from "@/modules/core/components/CoreModal"
import CrmIcon from "@/components/CrmIcon"
import JList from "@/components/JList"
import JButton from "@/components/JButton"

import AddDiscount from "./AddDiscount"

export default {
	components: {
		CoreModal,
		CrmIcon,
		JButton,
		JList,
		AddDiscount
	},
	props: {
		id: {
			type: String
		},
		hasDiscountActions: {
			type: Boolean
		},
		hasDiscountLogic: {
			type: Boolean
		},
		pricing: {
			type: Object
		},
		removeDiscount: {
			type: Function
		},
		addDiscountWithCode: {
			type: Function
		},
		addDiscountWithoutCode: {
			type: Function
		},
		nameOptions: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		computedDiscounts() {
			const appliedDiscounts = this.pricing.appliedDiscounts
				? this.pricing.appliedDiscounts
				: []

			const getValue = item => {
				if (!item) return ""
				const ratio = item.ratio ? item.ratio * 100 : null
				const flat = item.formattedFlat ? item.formattedFlat : ""
				return {
					flat,
					summary: `(${ratio ? ratio.toFixed(2) : "0"}% of ${
						item.formattedOriginalPrice
					})`
				}
			}

			return [
				...appliedDiscounts.map(item => ({
					id: item.id,
					code: item.code,
					label: item.name ? item.name : item.code,
					value: getValue(item).flat,
					summary: getValue(item).summary,
					order: item.order
				}))
			]
		}
	}
}
</script>

<style></style>
